import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import useAuth from "../../utils/hooks/useAuth";
import SmashLoader from "../../components/Loader/SmashLoader";

const VerifyEmailToken = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { verifyEmailToken } = useAuth();

  const hasVerified = useRef(false); // ✅ Prevent multiple calls

  const [status, setStatus] = useState("pending");
  const [message, setMessage] = useState("Verifying your email...");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (hasVerified.current) return;
    hasVerified.current = true;

    const verify = async () => {
      const result = await verifyEmailToken(token);
      setIsLoading(false);

      if (result.success) {
        setStatus("success");
        setMessage(result.message + " Redirecting to login...");
        setTimeout(() => navigate("/login"), 5000);
      } else {
        setStatus("error");
        setMessage(result.message);
      }
    };

    verify();
  }, [token, navigate, verifyEmailToken]);

  // Show loader while verifying
  if (isLoading) {
    return (
      <div className="flex min-h-[calc(100vh-4rem)] w-full flex-row items-start justify-center overflow-y-auto bg-blue-50 p-6 dark:bg-slate-900">
        <div className="flex flex-col justify-start flex-grow items-center w-full lg:pr-8 h-full max-h-[620px] pt-8">
          <div className="flex flex-col items-center justify-center flex-grow w-full">
            <SmashLoader />
            <p className="text-stone-500 dark:text-stone-400 text-opacity-80 text-lg text-center mt-4">
              Checking verification link...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-[calc(100vh-4rem)] w-full flex-row items-start justify-center overflow-y-auto bg-blue-50 p-6 dark:bg-slate-900">
      <div className="flex flex-col justify-start flex-grow items-center w-full lg:pr-8 h-full max-h-[620px] pt-8">
        <div className="flex flex-col items-center justify-center flex-grow w-full">
          <div className="p-10 bg-white dark:bg-slate-800 rounded-2xl shadow-lg flex flex-col items-center gap-6 w-full max-w-md">
            <div className="text-center text-zinc-800 dark:text-zinc-200 text-3xl font-medium">
              Email Verification
            </div>
            <div
              className={`text-center text-opacity-80 text-lg ${
                status === "success" ? "text-green-500" : "text-red-500"
              }`}
            >
              {message}
            </div>

            {status === "error" && (
              <button
                onClick={() => navigate("/register")}
                className="w-full h-12 bg-blue-950 dark:bg-blue-700 text-white rounded-xl hover:opacity-80"
              >
                Go Back to Register
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailToken;
